import { isTauri } from '@heidi/runtime/platform';

/** Document id from `router.query.id` (catch-all segment or desktop `?id=`). */
export function getInboxIdFromQuery(
  id: string | string[] | undefined
): string | undefined {
  return Array.isArray(id) ? id[0] : id;
}

const extractSearchParam = (
  href: string | null | undefined,
  param: string
): string | null => {
  if (!href) return null;
  try {
    return new URL(href).searchParams.get(param);
  } catch {
    return new URLSearchParams(href.split('?')[1] ?? '').get(param);
  }
};

const inboxPathWithoutQuery = (href: string): string =>
  (href.split(/[?#]/)[0] ?? '').replace(/\/+$/, '');

/** Document id from an inmail action link: `/inbox/<id>`, `/inbox?id=`, or legacy `/inbox/success?id=`. */
export function extractInboxDocumentId(href: string | null | undefined): string | null {
  if (!href) return null;
  const segment = href.match(/\/inbox\/([^/?#]+)/)?.[1];
  if (segment === 'success') return extractSearchParam(href, 'id');
  if (segment) {
    try {
      return decodeURIComponent(segment);
    } catch {
      return null;
    }
  }
  if (inboxPathWithoutQuery(href).endsWith('/inbox')) {
    return extractSearchParam(href, 'id');
  }
  return null;
}

/** Inbox document href; desktop uses `?id=` so reload hits the exported `/inbox` root. */
export function inboxDocumentHref(documentId: string | null): string {
  if (!documentId) return '/inbox';
  const encoded = encodeURIComponent(documentId);
  return isTauri() ? `/inbox?id=${encoded}` : `/inbox/${encoded}`;
}
